import { render, staticRenderFns } from "./Picking_y_packing.vue?vue&type=template&id=353a3368&scoped=true&"
import script from "./Picking_y_packing.vue?vue&type=script&lang=js&"
export * from "./Picking_y_packing.vue?vue&type=script&lang=js&"
import style0 from "./Picking_y_packing.vue?vue&type=style&index=0&id=353a3368&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353a3368",
  null
  
)

export default component.exports